import { getSiteUrl, LOGO_URL } from './config';

function getJsonLdForPath(path: string): Record<string, unknown>[] {
  const siteUrl = getSiteUrl();
  const orgId = siteUrl ? `${siteUrl}/#organization` : '#organization';
  const webSiteId = siteUrl ? `${siteUrl}/#website` : '#website';

  if (path === '/') {
    return [
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        '@id': orgId,
        name: 'Somukoi',
        url: siteUrl || undefined,
        logo: LOGO_URL,
        description:
          'Citizen journalism platform empowering communities across Northeast India through stories, culture, and innovation.',
        foundingLocation: {
          '@type': 'Place',
          name: 'Northeast India',
        },
        parentOrganization: {
          '@type': 'Organization',
          name: 'Xpec Innovations Pvt. Ltd.',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        '@id': webSiteId,
        name: 'Somukoi',
        url: siteUrl || undefined,
        publisher: {
          '@id': orgId,
        },
      },
    ];
  }

  if (path === '/blogs') {
    return [
      {
        '@context': 'https://schema.org',
        '@type': 'Blog',
        '@id': siteUrl ? `${siteUrl}/blogs#blog` : '#blog',
        name: 'Somukoi Community Stories',
        description: 'Community stories, culture, and innovations from Northeast India.',
        url: siteUrl ? `${siteUrl}/blogs` : undefined,
        publisher: {
          '@id': orgId,
        },
      },
    ];
  }

  return [];
}

export function injectJsonLd(path: string): void {
  document.querySelectorAll('script[data-seo-jsonld]').forEach((el) => el.remove());

  const schemas = getJsonLdForPath(path);
  schemas.forEach((schema, index) => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-seo-jsonld', `seo-jsonld-${index}`);
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
  });
}